import React, {
    useEffect,
    useState
} from "react";

import UserSecurityHeader from "../components/UserSecurityHeader";
import UserSecuritySummary from "../components/UserSecuritySummary";
import UserSearchCard from "../components/UserSearchCard";
import UserGrid from "../components/UserGrid";

import UserSecurityDrawer
from "../components/UserSecurityDrawer";


import userSecurityService
    from "../services/userSecurityService";

import {

    getTenants,

    getLocations,

    getDepartments

} from "../services/masterService";


const UserSecurityPage = () => {

    const [loading, setLoading] = useState(false);

    const [users, setUsers] = useState([]);

    const [summary, setSummary] = useState({

        totalUsers: 0,

        activeUsers: 0,

        usersWithOverrides: 0,

        additionalAccess: 0

    });
    const [tenants, setTenants] = useState([]);

const [locations, setLocations] = useState([]);

const [departments, setDepartments] = useState([]);

const [filters, setFilters] = useState({

    tenant_id: "",

    location_id: "",

    department_id: "",

    search: ""

});
    const [selectedUser, setSelectedUser] = useState(null);

    const [drawerOpen, setDrawerOpen] = useState(false);

    const openSecurity = (user) => {

        setSelectedUser(user);

        setDrawerOpen(true);

    };

    const closeSecurity = () => {

        setDrawerOpen(false);

        setSelectedUser(null);

    };

    const loadUsers = async (filters = {}) => {

        try {

            setLoading(true);

            const data =
                await userSecurityService.searchUsers(filters);

            setUsers(data);

            setSummary({

                totalUsers: data.length,

                activeUsers: data.filter(
                    x => x.is_active
                ).length,

                // Backend will provide these later
                usersWithOverrides: 0,

                additionalAccess: 0

            });

        }

        catch (error) {

            console.error(
                "Failed to load users",
                error
            );

        }

        finally {

            setLoading(false);

        }

    };
    const loadMasters = async () => {

        try {

            const tenantData = await getTenants();

            setTenants(tenantData);

        }

        catch (err) {

            console.error(err);

        }

    };

    const loadLocations = async (tenantId) => {

    try {

        const data = await getLocations(
            tenantId
        );

        setLocations(data);

    }

    catch (err) {

        console.error(err);

    }

};
const loadDepartments = async (
    tenantId,
    locationId
) => {

    try {

        const data = await getDepartments(
            tenantId,
            locationId
        );

        setDepartments(data);

    }

    catch (err) {

        console.error(err);

    }

};
    useEffect(() => {

        loadUsers();
        loadMasters();
    }, []);

    // =====================================================
// Load Locations when Tenant changes
// =====================================================

useEffect(() => {

    if (!filters.tenant_id) {

        setLocations([]);

        setDepartments([]);

        return;

    }

    loadLocations(
        filters.tenant_id
    );

    setDepartments([]);

}, [filters.tenant_id]);

// =====================================================
// Load Departments when Location changes
// =====================================================

useEffect(() => {

    if (

        !filters.tenant_id ||

        !filters.location_id

    ) {

        setDepartments([]);

        return;

    }

    loadDepartments(

        filters.tenant_id,

        filters.location_id

    );

}, [

    filters.tenant_id,

    filters.location_id

]);

    return (

        <div className="container-fluid">

            <UserSecurityHeader />

            <UserSecuritySummary
                summary={summary}
            />

            <UserSearchCard

                tenants={tenants}

                locations={locations}

                departments={departments}

                filters={filters}

                setFilters={setFilters}

                onSearch={loadUsers}

            />

            <UserGrid
                users={users}
                loading={loading}
                onOpen={openSecurity}
            />

            <UserSecurityDrawer

                show={drawerOpen}

                user={selectedUser}

                onClose={closeSecurity}

            />
        </div>

    );

};

export default UserSecurityPage;